import { render, staticRenderFns } from "./NbNewUploaderPdfPreview.vue?vue&type=template&id=6e97d1a1&scoped=true&lang=pug"
import script from "./NbNewUploaderPdfPreview.vue?vue&type=script&lang=ts"
export * from "./NbNewUploaderPdfPreview.vue?vue&type=script&lang=ts"
import style0 from "./NbNewUploaderPdfPreview.vue?vue&type=style&index=0&id=6e97d1a1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97d1a1",
  null
  
)

export default component.exports